<template>
  <v-page-content>
    <div v-if="loaded">
      <b-button v-b-toggle.collapse-1 variant="primary">Фильтры <em class="fas fa-filter"></em></b-button>
      <b-collapse id="collapse-1" class="mt-2" visible>
      <b-card>
        <ProfessionInterestedFilter v-if="loaded"
          @filter="onFilterChanged" 
          :cities="cities" 
          :studyOrganizations="usersOrganizations"
          :classes="classes"
          :interestedDo="interestedDo"
          :interestedProfessions="interestedProfessions"
          :interestedDoValue = "interestedDoValue"
          :interestedProfessionsValue="interestedProfessionsValue"
          :citizenships="citizenships"
        ></ProfessionInterestedFilter>
      </b-card>
    </b-collapse>
      <div v-for="user of users">
        <b-card class="mt-2" :class="classesToHide[user.id]">
          <div class="d-flex justify-content-between">
            <h5>Рег. номер: {{user.id}}</h5>
            <div class="clickable" v-if="!isUserMarked(user)" @click="markUser(user.id)">
              <em class="far fa-bookmark" v-b-tooltip title="Добавить ученика в избранное"></em>        
            </div>
            <div class="clickable" v-else @click="unmarkUser(user.id)">
              <em class="fas fa-bookmark" v-b-tooltip title="Убрать ученика из избранного"></em>        
            </div>
          </div>
          <div style="color:gray">
            <div>{{user.organization.title}}</div>
            <div>{{userClass(user.studentProfile.class)}}</div>
          </div>
          <div class="text-right">
            <router-link :to="`/student/list/${user.id}`" target="_blank">Портфолио ученика</router-link>
          </div>
        </b-card>
      </div>
    </div>
    <div v-else>
      <div class="text-center align-middle">
        <b-spinner label="Spinning" variant="primary"></b-spinner>
      </div>
    </div>
  </v-page-content>
</template>

<script>
import ProfessionInterestedFilter from '@/components/admin/recommendations/ProfessionInterestedFilter.vue';
import UsersAPI from '@/api/users'
import RecommendationAPI from '@/api/recommendation'
import OrganizationAPI from '@/api/organization'
import { mapActions, mapGetters } from 'vuex';
import COUNTRIES from "@/components/helpers/countries-to-select.json"

export default {
  name: 'ProfessionInterested',
  components: {
    ProfessionInterestedFilter
  },
  data() {
    return {
      filter: {},
      users: [],
      cities: [],
      usersOrganizations: [],
      classes: [],
      interestedDo: [],
      interestedProfessions: [],
      userMarks: [],
      interestedDoValue: [],
      interestedProfessionsValue: [],
      loaded: false,
      testMarks: [],
      olympiads: [],
      usersScore: {},
      classesToHide: {},
      citizenships:null
    }
  },
  async created() {
    await this.getUsers();
    await this.getCities();
    await this.getUsersOrganizations();
    await this.getUsersClasses();
   
    await this.getInterestedDo();
    await this.getInterestedProfessions();
    await this.getOlympiads();
    await this.getUserMarks();
    await this.getTestsMarks();

    if(this.$route.query.orgId) {
      const org = await OrganizationAPI.getOrganizationById(this.$route.query.orgId);
      this.interestedDoValue = [org.data]
    }
    if(this.$route.query.profId) {
      const prof = await RecommendationAPI.getProfession(this.$route.query.profId);
      this.interestedProfessionsValue = [prof.data.professions]
    }
    let allUsersCountries = _.uniq(this.users.map(d => d.studentProfile.citizenship));
    allUsersCountries = _.filter(allUsersCountries, (d) => d !== null);
    this.citizenships = allUsersCountries.map((d) => ({value: d, text: COUNTRIES.find((r) => r.value === d).text}))
    this.loaded = true
  },
  computed: {
    ...mapGetters({
      storedUsersInterestedInProfession: 'profession/getUsersInterestedInProfessions',
      storedAllUsersOlympiadsResults: 'profession/getAllUsersOlympiadsResults'
    }),
  },
  methods: {
    ...mapActions({
      setUsersInterestedInProfessions: 'profession/fetchUsersInterestedInProfessions',
      setAllUsersOlympiadsResults: 'profession/fetchAllUsersOlympiadsResults'
    }),
    async getOlympiads() {
      if(this.$store.state.profession.allUsersOlympadsResults === null
      ) {
        await this.setAllUsersOlympiadsResults();
      }
      let tmp = this.storedAllUsersOlympiadsResults;
      tmp = _.groupBy(tmp, 'userId');
      for(const user of this.users) {
        if(tmp[user.id]) {
          for(const value of tmp[user.id]) {
            let score = 0;
            if(value.stage === "отборочный")
              score += 1;
            if(value.stage === "заключительный")
              score += 1.2;
            if(value.result === "Победитель") 
              score += 2;
            this.usersScore[value.userId] += score;
          }
        }
      }
    },
    async getTestsMarks() {
      const tmp = (await UsersAPI.getAllUsersTestsMarks()).data;
      for(const value of tmp) {
        if(value.mark)
          this.usersScore[value.userId] += (value.mark/100);
      }
    },
    async getUsers() {
      if(this.$store.state.profession.usersInterestedInProfessions === null 
        || !_.isEqual(this.$store.state.profession.usersInterestedInProfessions, this.usersInterestedInProfessions)) {
        await this.setUsersInterestedInProfessions();
      }
      this.users = _.sortBy(this.storedUsersInterestedInProfession, 'id');
      for(const user of this.users) {
        this.usersScore[user.id] = 0;
      }
    },
    async markUser(id) {
      await UsersAPI.markInterestedInProfessionStudent(id);
      await this.getUserMarks();
    },
    async unmarkUser(id) {
      await UsersAPI.unmarkInterestedInProfessionStudent(id);
      await this.getUserMarks();
    },
    isUserMarked(user) {
      if(this.userMarks.some((d) => d.userId === user.id)) return true
      return false
    },
    async getUserMarks() {
      this.userMarks = (await UsersAPI.getUserInterestedInProfessionUsersMarks()).data;
    },
    getCities() {
      this.cities = this.users.map((d) => d.organization.city);
      this.cities = _.uniq(this.cities)
    },
    getUsersOrganizations() {
      this.usersOrganizations = this.users.map((d) => d.organization.title);
      this.usersOrganizations = _.uniq(this.usersOrganizations)
    },
    getUsersClasses() {
      this.classes = this.users.map((d) => d.studentProfile.class)
      this.classes = _.uniq(this.classes)
    },
    getInterestedDo() {
      for(const user of this.users) {
        for(const profession of user.professions) {
          this.interestedDo.push(profession.organization);
        }
      }
      this.interestedDo = _.uniqBy(this.interestedDo, 'id');
    },
    getInterestedProfessions() {
      for(const user of this.users) {
        for(const profession of user.professions) {
          this.interestedProfessions.push(profession);
        }
      }
      this.interestedProfessions = _.uniqBy(this.interestedProfessions, 'id');
    },
    onFilterChanged(filters) {
      if (_.isEqual(this.filter, filters)) {
        return
      }
      this.filter = _.cloneDeep(filters)  
      this.sortByAchievements(); 
      this.mainSort()
    },
    userClass(userClass) {
      if(userClass.includes('выпускник'))
        return 'Выпускник'
      else
        return `Ученик ${userClass}-го класса`
    },
    sortByCity(user) {
      if(this.filter.cities.length === 0)
        return true
      if(this.filter.cities.includes(user.organization.city))
        return true
      return false
    },
    sortByUserOrganization(user) {
      if(this.filter.studyOrganizations.length === 0)
        return true
      if(this.filter.studyOrganizations.includes(user.organization.title))
        return true
      return false
    },
    sortByCurrentClass(user) {
      if(this.filter.classes.length === 0)
        return true
      if(this.filter.classes.includes(user.studentProfile.class))
        return true
      return false
    },
    sortByInterestedDo(user) {
      if(this.filter.interestedDo.length === 0)
        return true
      for(const org of this.filter.interestedDo) {
        for(const profession of user.professions) {
          if(org.id === profession.organization.id) 
            return true
        }
      }
      return false
    },
    sortByInterestedProfessions(user) {
      if(this.filter.interestedProfessions.length === 0)
        return true
      for(const profession of this.filter.interestedProfessions) {
        if(user.professions.some((d) => d.id === profession.id))
          return true
      }
      return false
    },
    sortByAchievements() {
      if(this.filter.sortByAchievements) {
        this.users = _.orderBy(this.users, (d) => {return this.usersScore[d.id]}, ['desc'])
      }
      else {
        this.users = _.sortBy(this.users, 'id');
      }
    },
    markedSorted(user) {
      if(this.filter.onlyMarked) {
        if(this.isUserMarked(user))
          return true
        return false
      }
      else
        return true
    },
    genderSorted(user) {
      if(this.filter.gender === null) {
        return true
      }
      if(this.filter.gender.value === user.gender) {
        return true
      }
      return false
    },
    citizenshipSorted(user) {
      if(this.filter.citizenship === null) {
        return true;
      }
      if(this.filter.citizenship.value === user.studentProfile.citizenship) {
        return true
      }
      return false
    },
    filtersSort(user) {
      return this.sortByCity(user) 
        && this.sortByUserOrganization(user) 
        && this.sortByCurrentClass(user)
        && this.sortByInterestedDo(user)
        && this.sortByInterestedProfessions(user)
        && this.markedSorted(user)
        && this.genderSorted(user)
        && this.citizenshipSorted(user);
    },
    mainSort() {
      for(const user of this.users) {
        if(this.filtersSort(user)) {
          this.classesToHide[user.id] = '';
        }
        else {
          this.classesToHide[user.id] = 'd-none';
        }
      }
    },
    onOnlyMarkedClick() {
      if(this.onlyMarked) {
        for(const user of this.users) {
          if(!this.isUserMarked(user)) {
            this.classesToHide[user.id] = 'd-none';
          }
        }
      } else {
        for(const user of this.users) {
          if(!this.isUserMarked(user) && this.filtersSort(user)) {
            this.classesToHide[user.id] = '';
          }
          else if(!this.isUserMarked(user) && !this.filtersSort(user))
            this.classesToHide[user.id] = 'd-none';
        }
      }
    },
  }
}
</script>

<style scoped>
  .clickable {
    cursor: pointer;
  }
  ::v-deep .tooltip-inner {
    max-width: 160px !important;
  }
</style>
